// 言語を選ぶと、その言語の文章と36人のしくみを合わせたものが返る

import { PROSPERO_QUOTE, ROLES, type TypeId } from "../casting";
import { DEFAULT_LOCALE, type Locale } from "../i18n";
import { en } from "./en";
import { ja } from "./ja";
import type { ContentText, Role } from "./types";

export type { Role, TypeText } from "./types";

export interface Content extends ContentText {
  roleList: Role[];
  role(id: string): Role | undefined;
  prosperoQuote: { original: string; translation: string };
}

const TEXTS: Record<Locale, ContentText> = { ja, en };

function build(text: ContentText): Content {
  const roleList: Role[] = ROLES.map((r) => {
    const t = text.roles[r.id];
    return {
      id: r.id,
      front: r.front,
      back: r.back,
      name: t.name,
      play: t.play,
      word: t.word,
      intro: t.intro,
      quote: { original: r.quote, translation: t.quote },
      costar: { id: r.costar, reason: t.costarReason },
    };
  });
  const byId = new Map(roleList.map((r) => [r.id, r]));
  return {
    ...text,
    roleList,
    role: (id) => byId.get(id),
    prosperoQuote: { original: PROSPERO_QUOTE, translation: text.prospero.quote },
  };
}

const cache = new Map<Locale, Content>();

export function getContent(locale: Locale = DEFAULT_LOCALE): Content {
  let c = cache.get(locale);
  if (!c) cache.set(locale, (c = build(TEXTS[locale])));
  return c;
}

/** 配役の文 (行ごと) */
export const castingLines = (c: Content, role: Role) => c.castingText(role, c.types);

/** 「人前「戦士」× ひとり「夢見る人」」のような短い表示 */
export const typePairOf = (c: Content, front: TypeId, back: TypeId, joiner = c.locale === "ja" ? "× " : " × ") =>
  `${c.inPublic(c.types[front].label)}${joiner}${c.alone(c.types[back].label)}`;
